export enum Role {
  ADMIN = "admin",
  STANDARD = "standard",
}
